import React, { useState, useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import CollageModal from './CollageModal';
import './CollageButton.css';

/**
 * CollageButton component displays a button that opens a modal to generate and display a collage
 * 
 * @param {Object} props - Component props
 * @param {string} props.username - Username of the player
 * @param {string} props.overallRank - Player's overall rank in the tournament
 */
function CollageButton({ username, overallRank }) {
  const { theme } = useContext(ThemeContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Don't render the button if no username is provided
  if (!username) return null;
  
  return (
    <>
      <div className={`collage-button-container ${theme}`}>
        <button 
          className="generate-collage-button"
          onClick={() => setIsModalOpen(true)}
          aria-label="Generate Image Collage"
        >
          Generate Image Collage
        </button>
      </div>
      
      <CollageModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        username={username}
        overallRank={overallRank}
      />
    </>
  );
}

export default CollageButton;